"use client";

import Link from "next/link";
import { FaAngleRight } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePathname, useRouter } from "next/navigation";
import Image from "next/image";
import { BsThreeDotsVertical } from "react-icons/bs";
import Cookies from "js-cookie";
import { setUser } from "@/redux/slices/userSlice";
import { F_TOKEN_STORE_KEY } from "@/constants/storage";

export default function StudentTopNav({ logoutHandler }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const userInfo = useSelector((state) => state.user.userInfo);
  const router = useRouter();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const pathname = usePathname();
  const isStudentRoute = pathname.startsWith("/student");

  const linkHref = isStudentRoute ? "/" : "/student/dashboard";
  const linkText = isStudentRoute ? "ওয়েবসাইট" : "ড্যাশবোর্ড";

  const handleNavigation = (href) => {
    setIsOpen(false);
    router.push(href);
  };
  const dispatch = useDispatch();

const handleLogout = async () => {
  try {
    setIsOpen(false);
    await fetch("/api/logout", { method: "GET" });
    dispatch(setUser(null));
    Cookies.remove(F_TOKEN_STORE_KEY, { path: "/" });
    router.push("/login");
    router.refresh(); 
  } catch (error) {
    console.error("Logout failed:", error);
  }
};


  return (
    <div ref={menuRef} className="relative hidden lg:block">
      <div
        className="dashboard-student-profile"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="sutdent-profile-img">
          <div className="student-profile">
            <Image
              src={
                userInfo?.student?.profile_url ??
                "/images/admission-icon/student-profile-mobile.png"
              }
              className="profile-image"
              alt="Profile"
              width={40}
              height={40}
            />
          </div>
        </div>
        <div className="student-name-title ">
          <h2 className="stu-name">{userInfo?.name}</h2>
          <p className="title">এডমিশন ক্যান্ডিডেট</p>
        </div>
        <div className="open-dropdown">
          <button className="icon" onClick={() => setIsOpen(!isOpen)}>
            <BsThreeDotsVertical />
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="student-profile-dropdown-menu">
          <div
            className="dpdw-item"
            onClick={() => handleNavigation(linkHref)}
            style={{ cursor: "pointer" }}
          >
            <div className="item-content">
              <div className="icon">
                <Image
                  src="/images/admission-icon/go-to-web.avif"
                  className="dropdown-icon"
                  alt="icon"
                  width={24}
                  height={24}
                />
              </div>
              <span className="text">{linkText}</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </div>

          <div
            className="dpdw-item"
            onClick={() => handleNavigation("/student/profile")}
            style={{ cursor: "pointer" }}
          >
            <div className="item-content">
              <div className="icon">
                <Image
                  src={"/images/admission-icon/setting.avif"}
                  className="dropdown-icon"
                  alt={"icon"}
                  width={24}
                  height={24}
                />
              </div>
              <span className="text">সেটিংস</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </div>

          <div
            className="dpdw-item"
            onClick={()=>handleLogout()}
            style={{ cursor: "pointer" }}
          >
            <div className="item-content">
              <div className="icon">
                <Image
                  src={"/images/admission-icon/logout.avif"}
                  className="dropdown-icon"
                  alt={"icon"}
                  width={24}
                  height={24}
                />
              </div>
              <span className="text">লগআউট</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </div>
        </div>
      )}
    </div>
  );
}
